<template>
  <f7-page no-toolbar no-swipeback name="integral" class="page-integral" @page:init="onPageInit">
    <f7-navbar innerClass="navbar-inner-message" back-link :no-hariline="true">
      <f7-nav-title>{{ $t("integral_0015") }}</f7-nav-title>
    </f7-navbar>

    <div class="integral-wrap">
      <div class="tab-panel">
        <div v-if="show1==1" class="goods-list">
          <div class="goods-item" v-for="(item, index) in goodsList" :key="index">
            <div style="display: flex;">
              <div class="goods-img-wrap">
                <img class="goods-img" :src="item.ItemImageFileName" :onerror="`this.onerror='';this.src='${defaultGoodsImg}'`"/>
              </div>
              <div class="goods-body">
                <div class="goods-name">{{ item.BonusPointGoodsName || '--' }}</div>
                <div class="goods-price">{{ item.Price  | formatCurrency2}} {{ $t("integral_0003") }}</div>
                <div style="color: #999;font-size: 12px;">{{ item.CreateTS  | time}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="show1==2" class="no-data">
          <img
            :src="`../../static/images/yt999/noData_${$f7.params.currLang}.png`"
            :onerror="`this.onerror='';this.src='../../static/images/yt999/noData_enUS.png'`"
            alt="no-data"
          />
        </div>
      </div>
    </div>

  </f7-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getUserInfo, getBonusPointExchangeRecordByMemberList } from "../../axios/api";

export default {
  name: "Integral",
  data() {
    return {

      goodsList: [],
      defaultGoodsImg: "../../static/images/yt999/newss/integral/ok.png",
      show1:0,
    };
  },
  computed: {

  },
  methods: {
    onPageInit() {
      this.getBonusPointExchangeRecordByMemberList();
    },
    getBonusPointExchangeRecordByMemberList(){
      getBonusPointExchangeRecordByMemberList().then((data) => {
        if (data.Code === "NoError") {
          this.goodsList = data.Data;
          if (this.goodsList.length > 0) {
            this.show1 = 1;
          }else{
            this.show1 = 2;
          }
          
        }
      });
    },
    getUserInfo() {
      getUserInfo().then((data) => {
        if (data.Code === "NoError") {
          this.userInfo = data.Data;  
        }
      });
    },

  },
  created() {
    this.getUserInfo();
  },  
};
</script>

<style lang="less" scoped>
/deep/ .page-content{
    background: #f7f9fb;
}
.page-integral {

  .integral-wrap {
    padding: 12px;
  }

  .tab-panel {
    border-radius: 12px;
    background: transparent;
  }

  .goods-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .goods-item {
    border-radius: 12px;
    background: #fff;
    border: 1px solid rgba(166, 166, 166, 0.1);
    padding: 12px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);

    .goods-img-wrap {
      width: 78px;
      height: 78px;
      border-radius: 10px;
      background: #ececef;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      flex-shrink: 0;
      margin-right: 12px;

      .goods-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .goods-body {
      flex: 1;
      min-width: 0;
      .locked{
        background: #e6e9eb!important;
        color: #7b7373!important;
      }
    }

    .goods-name {
      color: #1f2128;
      font-size: 15px;
      font-weight: 700;
      line-height: 1.25;
      word-break: break-word;
    }

    .goods-price {
      color: var(--f7-THEME-color);
      font-weight: 800;
      margin-bottom: 8px;
    }

    .redeem-btn {
        border: none;
        outline: none;
        border-radius: 7px;
        padding: 6px 14px;
        color: #fff;
        background: var(--f7-THEME-color);
        font-size: 12px;
        font-weight: 700;
        // text-transform: uppercase;
        margin-bottom: 9px;
        width: 40%;
    }


    .eligibility {
      border-top: 1px solid #d9dce2;
      padding-top: 8px;
      margin-top: 2px;
    }

    .eligibility-label {
      color: #9da3b2;
      font-size: 12px;
      font-weight: 700;
      margin-bottom: 6px;
      text-transform: uppercase;
    }

    .vip-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;

      .vip-tag {
        background: #eaf1ff;
        color: var(--f7-THEME-color);
        border: 1px solid #d4d4d4;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 700;
        line-height: 1;
        padding: 4px 8px;
      }
    }
  }

  .no-data {
    padding: 28px 10px;
    display: flex;
    justify-content: center;

    img {
      width: 62%;
      max-width: 280px;
    }
  }


}

</style>